const API_URL = process.env.REACT_APP_API_URL;

let apiUrls = {
    elements: `${API_URL}/data-processing-elements`,
    saveDiscountTable: `${API_URL}/data-processing-element/save-discount-table`
};

export default apiUrls;
